// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CopyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Copy/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6.667 13.333H5c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667h6.667c.92 0 1.666.746 1.666 1.667v1.667m-5 10H15c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.747-1.666-1.667-1.666H8.333c-.92 0-1.666.746-1.666 1.666V15c0 .92.746 1.667 1.666 1.667Z"
}));
export default CopyIcon;
